export const DialBlocksQueryKeys = {
  all: () => ["dial-blocks"] as const,
  /** Every week's list: what a booking or a cancel invalidates. */
  weeks: () => ["dial-blocks", "week"] as const,
  week: (weekStart: string) => ["dial-blocks", "week", weekStart] as const,
  /** Whether the backend switch is on (the nav entry's probe). */
  switch: () => ["dial-blocks", "switch"] as const,
  /** The caller's dependability score (B6). */
  score: () => ["dial-blocks", "score"] as const,
};
